import { apiSlice } from "@/shared/api/api-slice"

export const cancelSubscriptionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessSubscription", "BusinessUsageStats", "GroupRating"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      cancelBusinessSubscription: builder.mutation<undefined, void>({
        query: () => ({
          url: "/api/v1/business/subscriptions",
          method: "DELETE"
        }),
        invalidatesTags: [
          { type: "BusinessSubscription" as const },
          { type: "BusinessUsageStats" as const },
          { type: "GroupRating" as const }
        ],
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled

            // Invalidate tags with retry pattern (eventual consistency)
            const tags = ["GroupRating", "BusinessSubscription", "BusinessUsageStats"] as const

            dispatch(cancelSubscriptionApi.util.invalidateTags([...tags]))
            setTimeout(() => {
              dispatch(cancelSubscriptionApi.util.invalidateTags([...tags]))
            }, 1000)
            setTimeout(() => {
              dispatch(cancelSubscriptionApi.util.invalidateTags([...tags]))
            }, 2500)
          } catch {
            // Error already handled by mutation
          }
        }
      })
    })
  })

export const { useCancelBusinessSubscriptionMutation } = cancelSubscriptionApi
